import { createNetworkQuality, NetworkQualitySDK, PrepareResultDE } from "@visonum/network-quality-sdk";
import * as R from "ramda";
import { baseUrl, API_KEY } from "../../config";
import { logger } from "../../helper/logger";
import { getUrlParamValue, getUrlQuery } from "../../helper/utils";
import { getMeasurementModeFromUrl } from "../getMeasurementModeFromUrl";
import { getPackageName, getPackageVersion } from "../../helper/packageJsonHelper";
import produce from "immer";

function mkDataOverride(url: string | null): ((prepareResult: PrepareResultDE) => PrepareResultDE) {
    const downloadServer = getUrlParamValue(url, "download-server");
    const uploadServer = getUrlParamValue(url, "upload-server");
    const wsPingServer = getUrlParamValue(url, "ws-ping-server");
    const downloadDuration = parseFloat(getUrlParamValue(url, "download-duration") ?? "");
    return (prepareResult: PrepareResultDE) => produce(prepareResult, draft => {
        if (!isNaN(downloadDuration)) {
            draft.config.download.duration = downloadDuration;
        }
        if (!R.isNil(downloadServer)) {
            draft.init.speedtest.servers.downloadServers = {
                dualstack: [downloadServer],
                ipv6: [downloadServer],
            }
        }
        if (!R.isNil(uploadServer)) {
            draft.init.speedtest.servers.uploadServer = {
                dualstack: uploadServer,
                ipv6: uploadServer,
            }
        }
        if (!R.isNil(wsPingServer)) {
            draft.init.speedtest.servers.wsPingServer = {
                dualstack: wsPingServer,
                ipv6: wsPingServer,
            }
        }

    })
}

export const createSdkJs = (url: string | null): NetworkQualitySDK => {
    const clientQueryString = getClientQueryStringFromUrl(url);
    if (!R.isNil(clientQueryString)) {
        logger.info(`Query String: "${clientQueryString}"`);
    }

    const mode = getMeasurementModeFromUrl(url);
    logger.info(`Measurement Mode: "${mode}"`);

    const sdk = createNetworkQuality(mode, baseUrl, API_KEY, {
        clientBundleId: getPackageName(),
        clientVersion: getPackageVersion(),
        clientQueryString,
        logger,
        dataOverride: mkDataOverride(url)
    });

    return sdk;
}

const getClientQueryStringFromUrl = (url: string | null) => getUrlQuery(url);